export default __webpack_public_path__ + "static/media/Jump (10).ee0fd876.png";